import { render, staticRenderFns } from "./DocumentScan.vue?vue&type=template&id=684343de&scoped=true&"
import script from "./DocumentScan.ts?vue&type=script&lang=ts&"
export * from "./DocumentScan.ts?vue&type=script&lang=ts&"
import style0 from "./DocumentScan.scss?vue&type=style&index=0&id=684343de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684343de",
  null
  
)

export default component.exports